<template>
  <div>
    <h2>Top Template!</h2>
    <p>aaaaa</p>
  </div>
</template>

<script>

export default {
  name: 'TopTemplate'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Templates/Top/index.vue